import { IntervalKey, PeriodKey } from './types';
import { IntervalConfig, PERIOD_ORDER } from './constants';

export function getAvailablePeriods(interval: IntervalKey): PeriodKey[] {
  const maxPeriod = IntervalConfig[interval].maxPeriod;
  const maxIdx = PERIOD_ORDER.indexOf(maxPeriod);
  return PERIOD_ORDER.slice(0, maxIdx + 1);
}

export function clampPeriod(
  period: PeriodKey,
  interval: IntervalKey,
): PeriodKey {
  const available = getAvailablePeriods(interval);
  if (available.includes(period)) return period;
  return available[available.length - 1];
}
